<template>
    <ul class="status_process" v-if="status>=0 && status<=5">
        <li v-for="index in [0, 1, 2]" :key="index" :class="status_class[status]&&status_class[status][index]?status_class[status][index]:''">
            <span>{{index==0?'US':index==1?'PD':index==2?'QA':''}}</span>
            <label>{{status_detail[status]&&status_detail[status][index]?status_detail[status][index]:''}}</label>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'PageStatus',
    props: {
        status: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            status_detail: [
                ['配置中', '', ''],
                ['已完成', '审核中', ''],
                ['已完成', '已驳回', ''],
                ['已完成', '已通过', '审核中'],
                ['已完成', '已通过', '已驳回'],
                ['已完成', '已通过', '已通过'],
            ],
            status_class: [
                ['ing', '', ''],
                ['finished', 'ing', ''],
                ['finished', 'error', ''],
                ['finished', 'finished', 'ing'],
                ['finished', 'finished', 'error'],
                ['finished', 'finished', 'finished'],
            ],
        }
    }
}
</script>

<style lang="less" scoped>
@primary-color: #1890ff; 
ul.status_process {
  display: inline-block;
  li {
      display: inline-block;
      width:50px;
      height: 50px;
      margin: 0 70px 0 0;
      vertical-align: middle;
      position: relative;
      text-align: center;
      span {
        display: block;
        width:30px;
        height:30px;
        line-height: 26px;
        background: #fff;
        border:2px solid #979797;
        border-radius: 15px;
        color:  #979797;
        text-align: center;
        margin:0 auto;
        &::before {
          position: absolute;
          content: " ";
          top: 15px;
          left: -80px;
          width: 90px;
          height: 1px;
          background: #979797;
        }
      }
      label {
        display: block;
        line-height: 20px;
      }
      &:first-child span::before {
        display: none;
        width:0;
      }
      &.ing {
        span {
          color:  @primary-color;
          border:2px solid @primary-color;
          &::before {
            background: @primary-color;
          }
        }
        label {
          color: @primary-color;
        }
      }
      &.finished {
        span {
          background: @primary-color;
          border:2px solid @primary-color;
          color: #fff;
          &::before {
            background: @primary-color;
          }
        }
        label {
          color: @primary-color;
        }
      }
      &.error {
        span {
          background: #F04864;;
          border:2px solid #F04864;;
          color: #fff;
          &::before {
            background: @primary-color;
          }
        }
        label {
          color: #F04864;;
        }
      }
  }
}
</style>